import type {
  Response,
  ReopenedApplicantResponse,
} from '@/lib/apollo/query/getReopenedApplicants/query'

import type { TransformedReopenedApplicantData, TransformedData } from './types'

export const toTransformedReopenedApplicantData = (
  reopenedApplicant: ReopenedApplicantResponse,
): TransformedReopenedApplicantData => ({
  ...reopenedApplicant,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getReopenedApplicants,
        results: response.getReopenedApplicants.results.map(
          toTransformedReopenedApplicantData,
        ),
      }
